import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { authV2Selector } from "@/store/slices/authV2Slice";

const useAuthInviteStep = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const authV2 = useSelector(authV2Selector);
  const setup = authV2?.invitationStatus?.setup;
  const invitation = authV2?.invitationStatus?.invitation;
  const nameConfigured = setup?.nameConfigured;
  const passwordConfigured = setup?.passwordConfigured;
  const mfaConfigured = setup?.mfaConfigured;
  const invitationState = invitation?.state;
  const hasInviteStatus = Boolean(setup && invitation);

  const navigateToStep = useCallback(() => {
    if (!hasInviteStatus) return;
    let nextPath = "";

    if (!nameConfigured) {
      nextPath = `/auth/invite/set-name${search}`;
    } else if (!passwordConfigured) {
      nextPath = `/auth/invite/set-password${search}`;
    } else if (!mfaConfigured) {
      nextPath = `/auth/invite/set-mfa${search}`;
    } else if (invitationState === "pending") {
      // At this point, the auth user has been configured.
      nextPath = `/auth/invite/accept${search}`;
    } else {
      nextPath = "/auth/sign-in";
    }

    if (`${pathname}${search}` === nextPath) return;
    navigate(nextPath);
  }, [
    hasInviteStatus,
    invitationState,
    mfaConfigured,
    navigate,
    nameConfigured,
    pathname,
    passwordConfigured,
    search,
  ]);

  return { navigateToStep };
};

export { useAuthInviteStep };
